<div
  class="fk-tooltip fk-caption2"
  [class.fk-tooltip--dark]="theme === 'dark'"
  [ngClass]="className"
  [style.width]="tooltipWidth"
  >
  {{ content }}
  @if (className) {
    <fk-icon class="fk-tooltip__arrow" name="tooltip-arrow"></fk-icon>
  }
</div>
